module.exports = __webpack_public_path__ + "static/media/phonegrid_hero.6430bb5e.mp4";